var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"elevation-0 title px-1 ma-0"},[_c('v-icon',{staticClass:"mr-1",attrs:{"color":"primary lighten-1"}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]),_c('span',{staticClass:"elevation-0 primary--text text--lighten-1 headline"},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }